var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseContent',_vm._g(_vm._b({class:_vm.contentClass,attrs:{"contentable-id":_vm.getThePageId,"contentable-type":"page","content":_vm.content},on:{"saveContent":_vm.saveContent,"saveDelete":_vm.saveDelete}},'BaseContent',{ ..._vm.$attrs, ..._vm.$props },false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }